import { render, staticRenderFns } from "./compareAdd.vue?vue&type=template&id=5833b376"
import script from "./compareAdd.vue?vue&type=script&lang=js"
export * from "./compareAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports